import { SemanticProjectId } from "@hex/common";

import { BrowserStorageKey } from "../../../hooks/useBrowserStorage";
import { SemanticProjectWorkbenchSidebarPanelId } from "../../../redux/slices/semanticProjectWorkbenchSlice";

/**
 * A copy of the same key in `hooks/useLocalStorage.ts` for use in redux slices since that
 * file is polluted with too many dependencies that cause integration tests to fail.
 */
export const SEMANTIC_PROJECT_WORKBENCH_RIGHT_SIDEBAR_PANEL_ID = (params: {
  semanticProjectId: SemanticProjectId;
}): BrowserStorageKey<SemanticProjectWorkbenchSidebarPanelId | null> => ({
  keyName: `semantic_project_${params.semanticProjectId}_workbench_right_sidebar_panel_id`,
  default: "chat",
});
